var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DocumentComparisonService from '~/api/submission-engine/documentComparisonService';
import { keysToSnake } from '~/utils/toSnakeCase';
const createDocumentComparison = (files) => __awaiter(void 0, void 0, void 0, function* () {
    const transformed = files.map(f => {
        return {
            txId: f.txId,
            fileId: f.id,
            fileName: f.name,
            docType: f.docType,
        };
    });
    return yield DocumentComparisonService.createComparison(keysToSnake(transformed));
});
export default createDocumentComparison;
